import type { ReactNode } from 'react';
import { useLocation } from 'react-router';
import { Button } from '@/components/Button/Button';
import { hasExternalFrameAncestor, isAccountRoutePathname } from '@/lib/accountFraming.mjs';

/** SPA navigation keeps the original document policy, so guard before mounting account views. */
export default function AccountRouteFrameBoundary({ children }: { children: ReactNode }) {
  const { pathname, search, hash } = useLocation();
  if (!isAccountRoutePathname(pathname) || !hasExternalFrameAncestor()) return children;

  return (
    <section className="mx-auto flex max-w-md flex-col items-start gap-4 px-6 py-12">
      <h1 className="text-heading font-semibold text-glyph-primary">
        Open your account on Atrivial
      </h1>
      <Button href={`${pathname}${search}${hash}`} target="_blank" rel="noopener" variant="primary">
        Open in a new tab
      </Button>
    </section>
  );
}
